import { useNavigate } from 'react-router';
import { useDraft } from '../../state/draft';
import { strings } from '@/theme';
import { showcaseDemoUrl } from '@/demos/webDemos';
import { Card, IconChip, Screen } from '../../ui';

/**
 * Ported from src/app/(onboarding)/intent.tsx — the same door, the same link, the same copy.
 *
 * There used to be a "Try example apps" card here. It went to /discover, which now only
 * redirects to Build, so pressing it dropped a person on the Build tab with no examples at all.
 * A real example is a published page on a public URL, so it is simply opened, as on the phone.
 */
export default function Intent() {
  const navigate = useNavigate();
  const setIntent = useDraft((s) => s.setIntent);
  const setKind = useDraft((s) => s.setKind);
  const reset = useDraft((s) => s.reset);

  return (
    <Screen title={strings.onboarding.intentTitle}>
      <p className="type-body intent-sub">{strings.onboarding.intentSubtitle}</p>

      <Card
        className="intent-card"
        accessibilityLabel={strings.onboarding.buildCardTitle}
        onPress={() => {
          reset();
          setIntent('build');
          setKind('personal');
          navigate('/new/idea', { replace: true });
        }}
      >
        <IconChip icon="build" />
        <span className="type-heading">{strings.onboarding.buildCardTitle}</span>
        <span className="type-body intent-card-sub">{strings.onboarding.buildCardSub}</span>
      </Card>

      <a
        className="intent-peek"
        href={showcaseDemoUrl()}
        target="_blank"
        rel="noreferrer"
        aria-label={strings.onboarding.peekLinkLabel}
      >
        {strings.onboarding.peekLink}
      </a>
    </Screen>
  );
}
